import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";

export const useAllSaveTests = (
  physicalEntryRef,
  pathologyEntryRef,
  xrayEntryRef
) => {
  return useMutation({
    mutationFn: async () => {
      const physicalPromise = physicalEntryRef.current
        ? physicalEntryRef.current.savePhysicalReport()
        : Promise.resolve();

      const pathologyPromise = pathologyEntryRef.current
        ? pathologyEntryRef.current.savePathologyReport()
        : Promise.resolve();

      const xrayPromise = xrayEntryRef.current
        ? xrayEntryRef.current.saveRadiologyReport()
        : Promise.resolve();

      return Promise.all([physicalPromise, pathologyPromise, xrayPromise]);
    },
    onSuccess: () => {
      toast.success("All Tests saved successfully!");
    },
    onError: (error) => {
      toast.error("Failed to save all tests.");
      console.error(error);
    },
  });
};
